import {initializeApp} from "firebase/app";
import {getAuth, GoogleAuthProvider} from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyBsBiVh4Pok4BtuCXsqZ4ZWaFr61JugHls",
  authDomain: "kitchentodoor-9856e.firebaseapp.com",
  projectId: "kitchentodoor-9856e",
  storageBucket: "kitchentodoor-9856e.appspot.com",
  messagingSenderId: "227850091316",
  appId: "1:227850091316:web:7a94d7e9f4f6e337234361",
  measurementId: "G-GTREXT7BS9",
};

//Initializing firebase app
const app = initializeApp(firebaseConfig);

//Initializing firebase authentication
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();


